import type { ReactNode } from 'react'
import type { UseMeasureRect } from 'react-use/lib/useMeasure'

import { createContext, useContext } from 'react'
import { useMeasure } from 'react-use'

type Measure = UseMeasureRect | undefined
const MeasureContext = createContext<Measure>(undefined)

export function ParentMeasureProvider ({ children }: {children: ReactNode}): JSX.Element {
  const [ ref, measure ] = useMeasure<HTMLDivElement>()

  return (
    <MeasureContext.Provider value={measure}>
      <div ref={ref}>
        {children}
      </div>
    </MeasureContext.Provider>
  )
}

export function useParentMeasure (): Measure {
  return useContext(MeasureContext)
}
